export const title = `TRADEMARK REGISTRATION`

export const content_first_p1 = `
    Trademark registration services are one other service our company does for interested applicants who want to obtain Intellectual Property for their business or trade name. This application is straightforward and made possible online via the myipo.gov.my website. However, to ease off headaches and petty queries our company will do the job for you. We will also do the search if your intended business name has been taken. 
`

export const content_second_p1 = `
    All you need to do is to furnish with us the details and particulars as per the list given.  
`